<template>
  <div class="fields-main">
    <div v-for="field in form" :key="field.fieldName">
      <sk-select
        v-if="field.displayType == 4"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-radio
        v-if="field.displayType == 3"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox-select
        v-if="field.displayType == 6"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox
        v-if="field.displayType == 5"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-img
        v-if="field.displayType == 7"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-file
        v-if="field.displayType == 8"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-input
        v-if="field.displayType == 1"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :sms-type="'questionary'"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-textarea
        v-if="field.displayType == 2"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-date-picker
        v-if="field.fieldType == 'DATETIME'"
        v-show="field.isShow"
        :field="field"
        :check-flag="field.checkFlag"
        :field-value.sync="field.value"
        @change="valueChange"
      />
      <sk-line v-if="field.fieldType === 'LINE'" />
      <sk-desc v-if="field.fieldType === 'DESC'" :field="field" />
      <sk-radio-img
        v-if="field.type == 9"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-checkbox-img
        v-if="field.type == 10"
        v-show="field.isShow"
        :check-flag="field.checkFlag"
        :field="field"
        :field-style="extraItem.extras('formfield.model') || 'style1'"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
        @change="valueChange"
      />
      <sk-policy
        v-if="field.fieldType == 'POLICY'"
        :check-flag="field.checkFlag"
        :field="field"
        :field-value.sync="field.value"
        :field-result.sync="field.result"
      />
    </div>
  </div>
</template>

<script>
import rulesMixin from "../mixins/option-rules";
export default {
  name: "PcFields",
  mixins: [rulesMixin],
  props: {
    form: Array,
    extras: Object,
  },
  data() {
    return {
      userSelectValues: {},
    };
  },
};
</script>

<style scoped lang="scss">
::v-deep .m-checkbox-list,
::v-deep .m-radio-list {
  &.img-list {
    padding: 0;
    .opts {
      width: 170px;
      margin-top: 0;
      margin-bottom: 20px;
      margin-right: 23px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .opt-img {
        height: 102px;
        img {
          height: 102px;
        }
      }
    }
  }
}
</style>
